
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.976 10.31a3.333 3.333 0 012.357-.976h5.334A3.333 3.333 0 0114 12.667v1.334a.667.667 0 01-1.333 0v-1.334a2 2 0 00-2-2H5.333a2 2 0 00-2 2v1.334A.667.667 0 012 14v-1.334c0-.884.351-1.732.976-2.357zM8 2.667a2 2 0 100 4 2 2 0 000-4zm-3.333 2a3.333 3.333 0 116.666 0 3.333 3.333 0 01-6.666 0z"}})])
          )
        }
      }
    